import { render } from "./LogoStrip.vue?vue&type=template&id=09ced298"
import script from "./LogoStrip.vue?vue&type=script&lang=js"
export * from "./LogoStrip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__